import { render, staticRenderFns } from "./CtaFooter.vue?vue&type=template&id=b32a3f14&scoped=true&"
import script from "./CtaFooter.vue?vue&type=script&lang=js&"
export * from "./CtaFooter.vue?vue&type=script&lang=js&"
import style0 from "./CtaFooter.vue?vue&type=style&index=0&id=b32a3f14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32a3f14",
  null
  
)

export default component.exports